import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { url as commonUrl } from '@finley-technologies/common';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { AgentVChat } from '~/packages/agentV/AgentVChat';

/**
 * AgentV chat, surfaced inside the backup-servicing customer portals
 * (lender + originator). Shared between both since it only needs the logged-in
 * user's own org.
 *
 * Unlike the admin page, the session is pinned to the caller's OWN org
 * (`user.organizationId`) — a BUS customer can only ever act on their own data.
 * The stream hits the borrower finleycore app (behind CloudFront); the shared
 * router there authenticates with the org-scoped borrower context.
 */
export const AgentView = (): React.ReactElement => {
  const { user } = useUserAuthOrThrow();

  return (
    <Box padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <Heading marginBottom="24px" display="inline-block">
        Assistant
      </Heading>
      <Text marginBottom="24px" color="gray.500">
        Ask about your backup-servicing setup.
      </Text>
      <AgentVChat
        streamUrl={commonUrl.getBorrowerExpressUrl('agent-v/stream')}
        targetOrganizationId={user.organizationId}
      />
    </Box>
  );
};
